module.exports = __webpack_public_path__ + "img/bg2_icon.7a201b09.jpg";